/* eslint-disable @typescript-eslint/naming-convention */

const COMMON_ENVIRONMENTS = {};

export const ENVIRONMENT = {
  dev: {
    production: false,
    SERVER_URL: '/api-dev',
    ...COMMON_ENVIRONMENTS,
    INTERNAL_DOMAINS: ['localhost', 'devlabs.qima.com', 'devlabs.qima.cn'],
    LOGIN_URL: 'https://openapi-dev.qima.com/auth2-service-cloud/v1.0/security/azure/login',
    LOGOUT_URL: 'https://openapi-dev.qima.com/auth2-service-cloud/v1.0/security/azure/logout',
  },
  pp: {
    production: false,
    SERVER_URL: '/api-pp',
    ...COMMON_ENVIRONMENTS,
    INTERNAL_DOMAINS: ['localhost', 'preprodlabs.qima.com', 'preprodlabs.qima.cn'],
    LOGIN_URL: 'https://openapi-preprod.qima.com/auth2-service-cloud/v1.0/security/azure/login',
    LOGOUT_URL: 'https://openapi-preprod.qima.com/auth2-service-cloud/v1.0/security/azure/logout',
  },
  staging: {
    production: false,
    SERVER_URL: '/api-staging',
    ...COMMON_ENVIRONMENTS,
    INTERNAL_DOMAINS: ['localhost', 'staginglabs.qima.com', 'staginglabs.qima.cn'],
    LOGIN_URL: 'https://openapi-staging.qima.com/auth2-service-cloud/v1.0/security/azure/login',
    LOGOUT_URL: 'https://openapi-staging.qima.com/auth2-service-cloud/v1.0/security/azure/logout',
  },
  prod: {
    production: true,
    SERVER_URL: '/api-prod',
    ...COMMON_ENVIRONMENTS,
    INTERNAL_DOMAINS: ['labs.qima.com'],
    LOGIN_URL: 'https://openapi.qima.com/auth2-service-cloud/v1.0/security/azure/login',
    LOGOUT_URL: 'https://openapi.qima.com/auth2-service-cloud/v1.0/security/azure/logout',
  },
};
